import React from 'react';
import { Modal, Form, Button, Row, Col, Spinner } from 'react-bootstrap';

const AddIndexModal = ({ show, onHide, handleAddIndex, loading }) => {
  return (
    <Modal size="lg" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Index</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleAddIndex}>
          <Row>
            <Col md={6}>
              <Form.Group controlId="indexName" className="mb-3">
                <Form.Label>Index Name</Form.Label>
                <Form.Control type="text" placeholder="e.g., NIFTY, BANKNIFTY" required />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="symboltoken" className="mb-3">
                <Form.Label>Symbol Token</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId="indexExchange" className="mb-3">
                <Form.Label>Index Exchange</Form.Label>
                <Form.Control type="text" placeholder="e.g., NSE or BSE" required />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="optionsExchange" className="mb-3">
                <Form.Label>Options Exchange</Form.Label>
                <Form.Control type="text" placeholder="e.g., NFO or BFO" required />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId="lotSize" className="mb-3">
                <Form.Label>Lot Size</Form.Label>
                <Form.Control type="number" required />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="maxLots" className="mb-3">
                <Form.Label>Max Lots</Form.Label>
                <Form.Control type="number" required />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId="profitPercentage" className="mb-3">
                <Form.Label>Profit %</Form.Label>
                <Form.Control type="number" step="0.05" required />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="workingFigure" className="mb-3">
                <Form.Label>Working Figure (Budget)</Form.Label>
                <Form.Control type="number" required />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId="step" className="mb-3">
                <Form.Label>Step Size</Form.Label>
                <Form.Control type="number" />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId="ceFile" className="mb-3">
                <Form.Label>CE Strikes (Excel)</Form.Label>
                <Form.Control type="file" accept=".xls,.xlsx" required />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="peFile" className="mb-3">
                <Form.Label>PE Strikes (Excel)</Form.Label>
                <Form.Control type="file" accept=".xls,.xlsx" required />
              </Form.Group>
            </Col>
          </Row>
          <div className="mt-3">
            <Button type="submit" className="me-2" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Adding Index...
                </>
              ) : (
                'Add Index'
              )}
            </Button>
            <Button variant="secondary" onClick={onHide} disabled={loading}>
              Cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddIndexModal;